"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_dom_1 = require("react-dom");
const ComponentsList_1 = require("./ComponentsList");
const thunkRenderExample_1 = require("./thunkRenderExample");
require('require1k');
const { __PRELOADED_STATE__: { components }, } = window;
R('./designsystemlibrary', (err, library) => {
    const componentNames = components.map((component) => component.name);
    (0, react_dom_1.render)(React.createElement(ComponentsList_1.ComponentsList, { components: components, renderExample: (0, thunkRenderExample_1.thunkRenderExample)(library, componentNames) }), document.getElementById('root'));
});
//# sourceMappingURL=App.js.map